import { render, staticRenderFns } from "./TituloValor.vue?vue&type=template&id=55645cfe"
import script from "./TituloValor.vue?vue&type=script&setup=true&lang=js"
export * from "./TituloValor.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports